import { Box, Stack, styled } from "@mui/material";

export const StyledWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  borderRadius: theme.spacing(1),
  border: "1px solid",
  borderColor: theme.palette.grey[200]
}));

export const StyledHeaderStack = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  height: "54px",
  borderBottom: "1px solid",
  borderColor: theme.palette.grey[200]
}));

export const StyledContentBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  maxHeight: 340,
  overflow: "auto"
}));
